"use client";

import playIcon from "@/assets/music-player/play.svg";
import playHover from "@/assets/voices/card/play-hover.svg";
import stopPressed from "@/assets/music-player/stop-pressed.svg";
import styles from "./styles/voice-info.module.scss";
import React from "react";
import VoicePlayButton from "@/components/pages/home/components/voices/voice-play-button";

type VoiceInfoProps = {
  title: string;
  url?: string;
  handleClick: () => void;
};

const VoiceInfo = ({ title, url, handleClick }: VoiceInfoProps) => {
  return (
    <div className={styles.info} onClick={handleClick}>
      <div
        className={styles.voice_info}
        style={{ width: url ? "80%" : "100%" }}
      >
        <div className={styles.artist_text}>{title}</div>
      </div>
      {url && (
        <VoicePlayButton
          baseIcon={playIcon}
          hoverIcon={playHover}
          activeIcon={stopPressed}
          url={url}
          size={32}
        />
      )}
    </div>
  );
};
export default VoiceInfo;
